import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { getFileExtension } from 'shared/lib/file';

// eslint-disable-next-line react/prop-types
const DocIcon = ({ doc }) => (
  <div className="doc-list-item-icon">
    <Icon name={_getFileExtensionClass(doc)} size={1} />
  </div>
);

export default DocIcon;

export const ExtensionMap = {
  '.jpg': 'file-image-o',
  '.jpeg': 'file-image-o',
  '.gif': 'file-image-o',
  '.png': 'file-image-o',
  '.pdf': 'file-pdf-o',
  '.xlsx': 'file-excel-o',
  '.xls': 'file-excel-o',
  '.mov': 'file-video-o',
  '.mp4': 'file-video-o',
  '.mp3': 'file-audio-o',
  '.wav': 'file-audio-o',
  '.doc': 'file-word-o',
  '.docx': 'file-word-o',
  '.ppt': 'file-powerpoint-o',
  '.pptx': 'file-powerpoint-o',
};

export const _getFileExtensionClass = (doc) => {
  let typeClassName = 'file-text-o';

  const fileName = doc.get('name');

  const extension = getFileExtension(fileName);

  if (!extension) return 'file-image-o';

  if (extension && ExtensionMap[extension]) {
    typeClassName = ExtensionMap[extension.toLowerCase()];
  }

  return typeClassName;
};
